import * as React from 'react';
import * as addMonths from 'date-fns/add_months';
import * as formatDate from 'date-fns/format';
import * as startOfMonth from 'date-fns/start_of_month';

import { AppState } from 'common/models/AppState';
import { EntityActions } from 'common/entity/EntityActions';
import { Formik, FormikProps } from 'formik';
import { Page } from 'common/components/layout/Page/Page';
import { RouteComponentProps } from 'react-router-dom';
import { getExportUrl } from 'common/utils/api';
import { Analytics } from 'common/utils/Analytics';
import { FormInput } from 'common/components/form/FormInput';

export interface ExportsProps extends RouteComponentProps<{}> {
  appState: AppState;
  entityActions: EntityActions;
}
interface ExportsFormValues {
  report: string;
  start: string;
  end: string;
}
export class Exports extends React.Component<ExportsProps> {
  handleSubmit = (values: ExportsFormValues) => {
    let exportCsvUrl = getExportUrl('/v1/transaction/export/' + values.report, {
      download: true,
      start: values.start,
      end: values.end,
      wcexport: false,
    });
    if (values.report === 'greatplainslegacy') {
      exportCsvUrl = getExportUrl('/v1/transaction/export/greatplains', {
        download: true,
        start: values.start,
        end: values.end,
        legacy: true,
        wcexport: false,
      });
    }
    if (values.report === 'greatplainswoocommerce') {
      exportCsvUrl = getExportUrl('/v1/transaction/export/greatplains', {
        download: true,
        start: values.start,
        end: values.end,
        legacy: false,
        wcexport: true,
      });
    }
    if (values.report === 'dues') {
      exportCsvUrl = getExportUrl('/v2/member/export/dues');
    }
    if (values.report === 'orders') {
      exportCsvUrl = getExportUrl('/v1/order/export', { download: true, start: values.start, end: values.end });
    }
    Analytics.export.generate({ name: values.report, start: values.start, end: values.end });
    window.location.href = exportCsvUrl;
  };

  getInitialValues = () => {
    const start = formatDate(startOfMonth(new Date()), 'YYYY-MM-DD');
    const end = formatDate(addMonths(start, 1), 'YYYY-MM-DD');
    return { report: 'greatplains', start, end };
  };

  render() {
    return (
      <Page title="Exports">
        <div className="card card-responsive" style={{ padding: 20 }}>
          <Formik
            initialValues={this.getInitialValues()}
            onSubmit={this.handleSubmit}
            render={(form: FormikProps<ExportsFormValues>) => (
              <div>
                <form onSubmit={form.handleSubmit}>
                  <div className="row">
                    <div className="col">
                      <FormInput label="Start" type="date" name="start" id="start" />
                    </div>
                    <div className="col">
                      <FormInput
                        label={form.values.report !== 'unearneddues' ? 'End' : 'Date'}
                        type="date"
                        name="end"
                        id="end"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-6">
                      <FormInput label="Report" tag="select" name="report" id="report" autoComplete="off">
                        <option value="greatplains">Great Plains</option>
                        {this.props.appState.config &&
                          this.props.appState.config.config.enableWooCommerce === true && (
                            <option value="greatplainswoocommerce">Great Plains (WooCommerce)</option>
                          )}

                        <option value="greatplainslegacy">Great Plains (Legacy Version)</option>
                        <option value="payments">Payments (Bank Reconciliation)</option>
                        <option value="receivabledues">Receivable Dues (Backout Unearned Revenue)</option>
                        <option value="dues">Member Dues Report</option>
                        <option value="orders">Orders</option>
                      </FormInput>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <input type="submit" className="btn btn-primary" value="Export CSV" />
                    </div>
                  </div>
                </form>
              </div>
            )}
          />
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Exports/Exports.tsx